import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { useWorkspace } from '../../stores';
import { listBookingRequests } from '../api/bookingApi';
export function useBookingRequests(status: number | 'all' = 0) {
  const { isDemo, store, scopeKey } = useWorkspace(); const demo = useDemo();
  const revision = isDemo ? demo.bookings.map(b => `${b.id}:${b.request_status}`).join('|') : '';
  return useQuery({ queryKey: [...scopeKey, 'booking-requests', status, revision], queryFn: ({ signal }) => isDemo ? Promise.resolve(demo.bookings.filter(b => b.store_id === store?.id && (status === 'all' || b.request_status === status))) : listBookingRequests(signal, status), enabled: Boolean(store?.id), staleTime: 30_000 });
}
